import { Component, OnInit } from '@angular/core';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { AdminAction } from 'src/app/models/adminaction.model';
import { UtilService } from 'src/app/services/util.service';
import { FeatureGroups } from 'src/app/models/school/schooladminitem.model';
import { SchoolModuleBatch } from 'src/app/models/module/moduledetails';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
declare const $: any;

@Component({
  selector: 'app-assessmentconsole',
  templateUrl: './assessmentconsole.component.html',
  styleUrls: ['./assessmentconsole.component.css'],
})
export class AssessmentconsoleComponent implements OnInit {
  adminActions: AdminAction[] = [];
  showCreateNewAssesmentwidget = false;
  ModalInvokerTimedAssessment: number;
  ModalInvokerTimedAssessmentBatch: number;
  isadmin = true;

  timedCount: number = 0;
  scoredCount: number = 0;
  submittedCount: number = 0;
  courseTitle: string;
  courseCode: string;
  crumbitem: any;
  FILTER_ALL: string = 'all';
  FILTER_TIMED: string = 'timed_val';
  FILTER_SCORED: string = 'scored_val';
  FILTER_ANSWERED: string = 'answered_val';
  filter: string = this.FILTER_ALL;
  isBatched = true;
  moduleBatches: SchoolModuleBatch[] = [];
  FilterByBatchText: number;

  constructor(
    private assessmentManager: AssessmentmanagerService,
    private router: Router,
    private activatedroute: ActivatedRoute,
    private header: ComponentheaderService,
    public moduleservice: ModulemanagementService,
    private util: UtilService
  ) {
    this.header.setHeaderDisplay('Assessment Manager Console', [], []);
    //clear out the local storage cache
    localStorage.removeItem(
      assessmentManager.LocalStorage_FLAG.currentAssessmentCache
    );
    localStorage.removeItem(assessmentManager.LocalStorage_FLAG.AssesmentTitle);
    localStorage.removeItem(assessmentManager.LocalStorage_FLAG.deliveryType);
    localStorage.removeItem(assessmentManager.LocalStorage_FLAG.questionType);
  }

  assessmentList: any[] = [];
  filteredAssessmentList: any[] = [];
  currentClassID: number;
  currentBatchID: number;

  async ngOnInit() {
    this.header.pageLoadingStarted(this);

    this.currentClassID = this.activatedroute.snapshot.queryParams.classid;
    this.currentBatchID = this.activatedroute.snapshot.queryParams.batchid;


    const response = await this.assessmentManager.getClassAssessments(this.currentClassID, this.currentBatchID);

    if(!await this.util.hasFeature(FeatureGroups.ASSESSMENTS)){
      if(response.isadmin){
        this.assessmentList = [];
        this.util.notifyFeatureNotAvailable(FeatureGroups.ASSESSMENTS);
        this.header.pageLoadingDone(this);
        this.router.navigate(['/user/lesson'], { queryParams: { classid: this.currentClassID }});
      }
      else{
        this.assessmentList = [];
      }
    }
    else{
      this.assessmentList = response.data;
    }
    this.filteredAssessmentList = this.assessmentList;
    this.crumbitem = response.breadcrumb;
    this.isadmin = response.isadmin;
    //this.courseTitle = this.crumbitem.moduleName;
    //this.courseCode = this.crumbitem.courseCode;
    this.countItems(this.assessmentList);

    this.showCreateNewAssesmentwidget = this.assessmentList.length < 1;
    this.moduleBatches = await this.moduleservice
      .getModuleBatches(this.crumbitem.moduleID)
      .toPromise();
      this.isBatched = this.moduleBatches.length > 0;

    if (response.isadmin) {
      this.adminActions = [
        {
          displaytext: 'Create Assessment',
          route: '/user/newassessment',
          params: { classid: this.currentClassID },
          classes: ['fas', 'fa-plus'],
        },
      ];
      this.FilterByBatchText = this.isBatched ? this.moduleBatches.find(
        (x) => x.id == response.batch
      )?.id : 0;

      if(this.FilterByBatchText == 0 && this.moduleBatches.length > 0){
        this.FilterByBatchText = this.moduleBatches[0].id;
      }
    }

    this.header.setHeaderDisplay("Assessments",
    [
      { displaytext:  'School', route: `/user/schoolhome`, params: { schoolID: this.crumbitem.schoolID } },
      { displaytext:  'Course', route: `/user/moduledetails`, params: { moduleID: this.crumbitem.moduleID } },
      { displaytext: 'Lesson', route: `/user/lesson`, params: { classid: this.currentClassID } },
      { displaytext: 'Assessments', route: `/user/assessmentconsole`, params: { classid: this.currentClassID, batchid: this.currentBatchID } }
    ],
    this.adminActions);
    this.header.pageLoadingDone(this);

  }

  countItems(assessmentlist:any[]){
    assessmentlist.forEach((item,index)=>{
        if(item.scored){ this.scoredCount++ }
        if(item.istimed){ this.timedCount++ }
        if(item.answered){ this.submittedCount++ }
      });
  }

  openAssessment(id: number, batchid: number) {
    this.router.navigate(['/user/assessmentdetails'], {
      queryParams: {
        aid: id,
        classid: this.currentClassID,
        batchid: batchid,
        target: this.assessmentManager.bufferRoute.Details,
      },
    });
  }

  openNewAssessment() {
    this.router.navigate(['/user/newassessment'], {
      queryParams: {
        classid: this.currentClassID,
        target: this.assessmentManager.bufferRoute.NewAssessment,
      },
    });
  }

  setModalInvokeParam(
    assessmentId: number,
    isactivesession: boolean,
    batchid: number
  ) {
    this.ModalInvokerTimedAssessment = assessmentId;
    this.ModalInvokerTimedAssessmentBatch = batchid;
    if (this.isadmin || isactivesession) {
      //trigger the close of the modal      
      $('#closeModal').trigger('click');
      //opent he assessment
      this.openAssessment(assessmentId, batchid);
    }
    else if (!this.isadmin) {
      $('#tmamodal').modal('show');
    }
   
    
  }

  viewfilter(filter: string, event) {
    // Initializing this.filteredAssessmentList to an empty array and using setTimeout because the browser doesn't re-render the whole list
    // which affects how the list-item style, particularly, for the border, is rendered
    this.filter = filter;
    this.filteredAssessmentList = [];
    let assessmentType: string;

    setTimeout(() => {
      switch (this.filter) {
        case this.FILTER_TIMED:
          assessmentType = 'istimed';
          break;
        case this.FILTER_SCORED:
          assessmentType = 'scored';
          break;
        case this.FILTER_ANSWERED:
          assessmentType = 'answered';
          break;
        default:
          this.filteredAssessmentList = this.assessmentList;
          return;
      }

      this.filteredAssessmentList = this.assessmentList.filter(
        (assessment) => assessment[assessmentType]
      );
    }, 0);
  }
  async sortByBatch(batchid: number) {
    this.assessmentManager
      .getClassAssessments(this.currentClassID, batchid)
      .then((response: any) => {
        if (response.isadmin) {
          this.assessmentList = response.data;
          this.timedCount = this.assessmentList.filter((a) => a.istimed).length;
          this.filteredAssessmentList = this.assessmentList;
        }
      });
  }
}
